import cx from 'classnames';
import React from 'react';
import Select, { components as originalComponents } from 'react-select';
import { Checkbox } from '@chaser/components';
import style from './ChaserStyledSelect.module.scss';

const Option = ({ innerRef, innerProps, isSelected, label }) => {
  return (
    <div ref={innerRef} className={cx(style.option, isSelected && style.value)} {...innerProps}>
      <Checkbox className={style.checkboxWrapper} checked={isSelected} readOnly>
        {label}
      </Checkbox>
    </div>
  );
};

const SingleValue = ({ children, ...props }) => {
  return (
    <originalComponents.SingleValue {...props}>
      {props.data.selectedLabel || children}
    </originalComponents.SingleValue>
  );
};

const MultiValue = ({ children, ...props }) => {
  return (
    <originalComponents.MultiValue {...props}>
      {props.data.selectedLabel || children}
    </originalComponents.MultiValue>
  );
};

const ChaserStyledSelect = ({ isMulti = false, as: Comp = Select, containerStyles = undefined, ...rest }) => {
  return (
    <Comp
      styles={{
        container: provided => ({
          ...provided,
          border: 'none',
          borderRadius: '6px',
          minHeight: '40px',
          ...containerStyles,
        }),
        control: (provided, state) => ({
          ...provided,
          minHeight: '40px',
          cursor: 'pointer',
          border: state.isFocused ? '1px solid #1B82BE' : '1px solid #d7dbe2',
          '&:hover': {
            border: state.isFocused ? '1px solid #1B82BE' : '1px solid #9ba1ae',
          },
        }),
        multiValueContainer: provided => ({
          ...provided,
          minHeight: '40px',
        }),
        multiValue: provided => ({
          ...provided,
          backgroundColor: '#F4F5F7',
          borderRadius: '6px',
        }),
        indicatorSeparator: provided => ({
          ...provided,
          display: 'none',
        }),
        dropdownIndicator: (provided, state) => ({
          ...provided,
          transform: state.selectProps.menuIsOpen && 'rotate(180deg)',
          color: state.isFocused ? '#1B82BE' : '#3C4757',
        }),
        input: provided => ({
          ...provided,
          height: '30px !important',
          padding: '0px',
          margin: '0px',
          input: {
            fontSize: '14px !important',
            height: '30px',
          },
        }),
        noOptionsMessage: provided => ({
          ...provided,
          color: '#9ba1ae',
          textAlign: 'left',
          fontSize: '14px',
        }),
        menuList: provided => ({
          ...provided,
          margin: '14px',
          padding: '0px',
        }),
        multiValueRemove: provided => ({
          ...provided,
          backgroundColor: '#F4F5F7',
          color: '#9ba1ae',
          cursor: 'pointer',
          '&:hover': {
            backgroundColor: '#F4F5F7',
            color: '#9ba1ae',
          },
        }),
        placeholder: (provided, state) => ({
          ...provided,
          fontSize: '14px',
          display: state.isFocused ? 'none' : 'block',
          color: '#9ba1ae',
        }),
      }}
      backspaceRemovesValue
      closeMenuOnSelect={!isMulti}
      hideSelectedOptions={false}
      isMulti={isMulti}
      placeholder={isMulti ? 'Select options' : 'Select an option'}
      noOptionsMessage={() => 'No options found'}
      delimiter=""
      components={{ Option, SingleValue, MultiValue }}
      maxMenuHeight={200}
      isClearable={false}
      {...rest}
    />
  );
};



export default ChaserStyledSelect;
